import { Snackbar, makeStyles } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../../../../reduxSaga/sagas/requests/currentUserId";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import ProductService from "../../../../../services/ProductService";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import $ from "jquery";
import update from "immutability-helper";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import Button from "@material-ui/core/Button";
import UOMService from "../../../../../services/Production/UOMService";
import OperationsService from "../../../../../services/Production/OperationsService";
import BOMService from "../../../../../services/Production/BOMService";
import withLoader from "../../../../../components/layouts/WithLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiStepIcon-root.MuiStepIcon-active ": {
      width: "100%",
      color: "#000000",
    },
    "& .MuiStepIcon-root.MuiStepIcon-completed": {
      color: "#000000",
    },
  },
  button: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  icon: {
    color: "#000",
  },
}));
function getSteps() {
  return [
    "Choisir le produit ",
    "Choisir les composants",
    "Choisir les déchets",
    "Choisir les opérations",
    "Finaliser",
  ];
}

const UpdateBOM = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [availableProducts, setAvailableProducts] = useState([]);
  const [availableProductsComponents, setAvailableProductsComponents] =
    useState([]);
  const [productId, setProductId] = useState(0);
  const [uom, setUOM] = useState(0);
  const [uomComposant, setUOMComposant] = useState(0);
  const [productComposantId, setProductComposantId] = useState(0);
  const [operationId, setOperationId] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [quantityComposant, setQuantityComposant] = useState(0);
  const [tempsReglage, setTempsReglage] = useState(0);
  const [tempsMachine, setTempsMachine] = useState(0);
  const [tempsTransfert, setTempsTransfert] = useState(0);
  const [ordreOperation, setOrdreOperation] = useState(1);
  const [productTableData, setProductTableData] = useState([]);
  const [productMapById, setProductMapById] = useState([]);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const animatedComponents = makeAnimated();
  const animatedProductComponents = makeAnimated();
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionComponent, setSelectedOptionComponent] = useState(null);
  const [selectedOptionUOM, setSelectedOptionUOM] = useState(null);
  const [selectedOptionUOMComposant, setSelectedOptionUOMComposants] =
    useState(null);
  const [allProducts, setAllProducts] = useState([{}]);
  const [allProductsComponents, setAllProductsComponents] = useState([{}]);
  const [activeStep, setActiveStep] = useState(0);
  const [productSelectPlaceHolder, setProductSelectPlaceHolder] =
    useState("Choisir...");
  const [
    productComposantSelectPlaceHolder,
    setProductComposantSelectPlaceHolder,
  ] = useState("Choisir...");
  const [operationSelectPlaceHolder, setOperationSelectPlaceHolder] =
    useState("Choisir...");
  const [uomSelectPlaceHolder, setUOMSelectPlaceHolder] =
    useState("Choisir...");
  const [uomComposantSelectPlaceHolder, setUOMComposantSelectPlaceHolder] =
    useState("Choisir...");
  const [extrats, setExtrats] = useState([]);
  const [showProduct, setShowProduct] = useState(false);
  const [allUOM, setAllUOM] = useState([]);
  const [allOperations, setAllOperations] = useState([]);
  const [availableUOM, setAvailableUOM] = useState([]);
  const [availableOperation, setAvailableOperation] = useState([]);
  const steps = getSteps();
  const [boms, setBoms] = useState(null);
  const animatedProductDechetComponents = makeAnimated();
  const [selectedOptionComponentDechet, setSelectedOptionComponentDechet] = useState(null);
  const [productDechetComposantId, setProductDechetComposantId] = useState(0);
  const [
    productDechetComposantSelectPlaceHolder,
    setProductDechetComposantSelectPlaceHolder,
  ] = useState("Choisir...");

    const [showProductDechet, setShowProductDechet] = useState(false);
   const [productDechetTableData, setProductDechetTableData] = useState([]);
    const [productDechetMapById, setProductDechetMapById] = useState([]);
  $(".custom-file-input").on("change", function () {
    var fileName = $(this).val().split("\\").pop();
    $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
  });

  useEffect(() => {
    startLoading();
    ProductService.getAllProductsOnPurshaseAndService(getCurrentUserId(), 1, 2)
      .then((response) => {
        setAvailableProductsComponents(response.data["Allproducts"]);
      })
      .catch((error) => {
        alert("erreur" + error);
      })
      .finally(() => {
        stopLoading();
      });
    UOMService.allUnitOfMesure(getCurrentUserId())
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setAvailableUOM(response.data.success);

          setAllUOM([]);
          response.data.success.map((element) => {
            setAllUOM((oldArray) => [
              ...oldArray,
              { value: element.id, label: element.code + "-" + element.name },
            ]);
          });
        } else if (response.data.empty) {
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de nomenclature");
        }
      })
      .catch((e) => {
        console.log("error", e);
      });

    OperationsService.allOperations(getCurrentUserId())
      .then((response) => {
        console.log("response", response);
        if (response.data.success) {
          setAvailableOperation(response.data.success);
          setAllOperations([]);
          response.data.success.map((element) => {
            setAllOperations((oldArray) => [
              ...oldArray,
              { value: element.id, label: element.code + "-" + element.name },
            ]);
          });
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas d'opération");
        }
      })
      .catch((e) => {
        console.log("error", e);
      });
  }, []);

  
  useEffect(() => {
    const fetchData = () => {
      startLoading();
      BOMService.getBOMById(localStorage.getItem("idBOM"))
        .then((response) => {
          const newProductData = response.data.success.componentList.map(
            (element) => ({
              productRef: `${element?.product.productCode}-${element?.product.barcode}-${element?.product.name}`,
              idProduct: element?.product.id,
              uom: element?.unitOfMeasure?.id,
              uomName: element?.unitOfMeasure?.name,
              quantity: element?.quantity,
            })
          );
  
          const newDechetData = response.data.success.dechetList && 
            response.data.success.dechetList.map((element) => ({
              productRef: `${element?.product.productCode}-${element?.product.barcode}-${element?.product.name}`,
              idProduct: element?.product.id,
              uom: element?.unitOfMeasure?.id,
              uomName: element?.unitOfMeasure?.name,
              quantity: element?.quantity,
            }));
  
          const newOperationData = response.data.success.operations.map(
            (element) => ({
              order: element.sequenceNumber,
              operationId: element.operation.id,
              operationName: element.operation.code + "-" + element.operation.name,
              tempsReglage: element.setupTime,
              tempsMachine: element.machineTime,
              tempsTransfert: element.transferTime,
            })
          );
          
          setOrdreOperation(newOperationData.length);
  
          return Promise.all([
            new Promise((resolve) => setProductTableData(newProductData, resolve)),
            new Promise((resolve) => setProductMapById(newProductData, resolve)),
            new Promise((resolve) => setProductMapById(newProductData, resolve)),
            new Promise((resolve) => setProductDechetTableData(newDechetData, resolve)),
            new Promise((resolve) => setProductDechetMapById(newDechetData, resolve)),
            new Promise((resolve) => setExtrats(newOperationData, resolve)),
            new Promise((resolve) => setBoms(response.data.success, resolve)),
          ]);
        })
        .then(() => {
          console.log("All states have been updated");
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          stopLoading();
        });
    };
  
    fetchData();
  }, []);
  useEffect(() => {
    console.log("productTableData has updated:", productTableData);
  }, [productTableData]);
  useEffect(() => {
    availableProducts &&
      availableProducts.map((element) => {
        let exist = false;
        if (allProducts.length !== 0) {
          for (let index = 0; index < allProducts.length; index++) {
            if (allProducts[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        let codeProduct = "*";
        if (element.productCode !== undefined) {
          codeProduct = element.productCode;
        }
        let barCodeProduct = "*";
        if (element.barcode) {
          barCodeProduct = element.barcode;
        }
        let label = codeProduct + "-" + barCodeProduct + "-" + element.name;
        if (element?.id !== undefined && exist === false) {
          setAllProducts((oldArray) => [
            ...oldArray,
            {
              value: element.id,
              label: label,
              customElements: element.typeProduct,
            },
          ]);
          setAllProductsComponents((oldArray) => [
            ...oldArray,
            {
              value: element.id,
              label: label,
              customElements: element.typeProduct,
            },
          ]);
        }
      });
  }, [availableProducts]);

  useEffect(() => {
    availableProductsComponents &&
      availableProductsComponents.map((element) => {
        let exist = false;
        if (allProducts.length !== 0) {
          for (let index = 0; index < allProducts.length; index++) {
            if (allProducts[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        let codeProduct = "*";
        if (element.productCode !== undefined) {
          codeProduct = element.productCode;
        }
        let barCodeProduct = "*";
        if (element.barcode) {
          barCodeProduct = element.barcode;
        }
        let label = codeProduct + "-" + barCodeProduct + "-" + element.name;
        if (element?.id !== undefined && exist === false) {
          setAllProductsComponents((oldArray) => [
            ...oldArray,
            {
              value: element.id,
              label: label,
              customElements: element.typeProduct,
            },
          ]);
        }
      });
  }, [availableProductsComponents]);

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  const onChangeQuantityHandler = (event) => {
    setQuantity(event.target.value);
  };
  const onChangeQuantityComposantHandler = (event) => {
    setQuantityComposant(event.target.value);
  };
  const onChangeTempsReglageHandler = (event) => {
    setTempsReglage(event.target.value);
  };
  const onChangeTempsMachineHandler = (event) => {
    setTempsMachine(event.target.value);
  };
  const onChangeTempsTransfertHandler = (event) => {
    setTempsTransfert(event.target.value);
  };
  const handleNext = () => {
    //   if (activeStep === 0 && productId === 0) {
    //     setOpenErrorAlert(true);
    //     setErrorAlertText("Erreur : Aucun produit ");
    //   } else
    if (activeStep === 0 && uom === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucun unité de mesure ");
    } else if (activeStep === 0 && quantity === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : quantité 0 ");
    } else if (activeStep === 0) {
      // setProductTableData([]);

      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 1 && productTableData.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucun composant ");
    } else if (activeStep === 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }  else if (activeStep === 2) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }else if (activeStep === 3 && extrats.length === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Aucune opération ");
    } else if (activeStep === 3) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (activeStep === 4) {
      let BOMModel = {
        idUser: getCurrentUserId(),
        idBOM: boms.id,
        operations: extrats,
        componentList: productTableData,
        dechetList: productDechetTableData,

        quantity: quantity,
        unitOfMesureId: uom,
      };

      console.log(JSON.stringify(BOMModel));
      onSendQuotationToBackendSystem(BOMModel);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const onChangeSelectedProduct = (selectedOptionn) => {
    setSelectedOption();
    setProductId(selectedOptionn.value);
    setProductSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedProductComposant = (selectedOptionn) => {
    setSelectedOptionComponent();
    setProductComposantId(selectedOptionn.value);
    setProductComposantSelectPlaceHolder(selectedOptionn.label);
    setShowProduct(true);
  };
  const onChangeSelectedOperation = (selectedOptionn) => {
    setSelectedOption();
    setOperationId(selectedOptionn.value);
    setOperationSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedUMO = (selectedOptionn) => {
    setSelectedOptionUOM();
    setUOM(selectedOptionn.value);
    setUOMSelectPlaceHolder(selectedOptionn.label);
  };
  const onChangeSelectedUMOComposant = (selectedOptionn) => {
    setSelectedOptionUOMComposants();
    setUOMComposant(selectedOptionn.value);
    setUOMComposantSelectPlaceHolder(selectedOptionn.label);
  };

  const onSendQuotationToBackendSystem = (BOMModel) => {
    BOMService.updateBOM(BOMModel)
      .then((response) => {
        if (response.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/bom`);
          }, 2000);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme au niveau de serveur");
        }
      })
      .catch((error) => {
        console.log("error", error);
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      });
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const columnsWithDelete = [
    {
      dataField: "productRef",
      text: "Libellé",
      headerAlign: "center",
    },
    {
      dataField: "quantity",
      text: "Qte",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },
    {
      dataField: "uomName",
      text: "Unité de mesure",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
    },

    {
      dataField: "idProduct",
      text: "Supprimer",
      formatter: (cell, row, rowIndex, extraData) => (
        <span>
          <button className="btn btn-danger">
            <i class="fas fa-trash"></i>
          </button>
        </span>
      ),
      events: {
        onClick: (e, column, columnIndex, row, rowIndex) => {
          console.log("productTableData", productTableData);

          setProductTableData(
            productTableData.filter((item) => item.idProduct !== row.idProduct)
          );
        },
      },
    },
  ];
  function handleTableChange({ productTableData }) {
    return productTableData;
  }

  function productDetail() {
    if (showProduct) {
      return (
        <>
          {" "}
          <div class="row">
            <div className="col-sm-6">
              <div className="form-group">
                <div>
                  <label>Choisir une unité de mesure</label>

                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionUOMComposant}
                    onChange={onChangeSelectedUMOComposant}
                    options={allUOM}
                    placeholder={uomComposantSelectPlaceHolder}
                  />
                </div>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="form-group">
                <label>Quantité</label>
                <input
                  onChange={onChangeQuantityComposantHandler}
                  value={quantityComposant}
                  type="number"
                  min="0"
                  id="quantity"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div className="col-sm-12  text-center">
              <button
                style={{ marginBottom: 20 }}
                className="btn btn-dark"
                onClick={onAddProductToList}
              >
                <i class="fas fa-plus"></i>
                Liste des composants{" "}
              </button>
            </div>
          </div>
        </>
      );
    }
  }

  const listOperations = () => {
    return (
      <div className="col-sm-12">
        {createUIOperation()}
        <br />
        <label></label>
        <button
          style={{ height: "40 px", width: "40 px" }}
          type="button"
          className="btn btn-dark float-right"
          onClick={addClickOperation}
        >
          <i class="fa fa-plus"></i>
        </button>
        {addExtratToViewParProduct()}
      </div>
    );
  };

  function addExtratToViewParProduct() {
    if (extrats.length === 0) {
      return (
        <div class="row">
          <div class="col-xs-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else if (
      extrats.length === 1 &&
      extrats[0]["order"] === "" &&
      extrats[0]["operationName"] === ""
    ) {
      return (
        <div class="row">
          <div class="col-xs-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else {
      return (
        <div className="table-responsive">
          <table className="table table-striped">
            <thead className="text-center">
              <td>Priorité</td>
              <td>operationName</td>
              <td>tempsReglage</td>
              <td>tempsMachine</td>
              <td>tempsTransfert</td>
              <td>Supprimer</td>
            </thead>
            <tbody>
              {extrats.map((extrat, i) => (
                <tr className="text-center">
                  <td>{extrat.order}</td>
                  <td>{extrat.operationName}</td>
                  <td>{extrat.tempsReglage}</td>
                  <td>{extrat.tempsMachine}</td>
                  <td>{extrat.tempsTransfert}</td>

                  <td>
                    <button
                      type="button"
                      class="btn btn-danger "
                      onClick={() => removeExtratOperation(i)}
                    >
                      <i class="fa fa-minus"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }
  const removeExtratOperation = (index) => {
    var array = [...extrats];

    if (index !== -1) {
      array.splice(index, 1);
      setExtrats(array);
    }
  };
  function addClickOperation() {
    setExtrats((oldArray) => [
      ...oldArray,
      {
        order: ordreOperation,
        operationId: operationId,
        operationName: operationSelectPlaceHolder,
        tempsReglage: tempsReglage,
        tempsMachine: tempsMachine,
        tempsTransfert: tempsTransfert,
      },
    ]);
    setOrdreOperation(ordreOperation + 1);
  }
  function createUIOperation() {
    return (
      <div class="row">
        <div className="col-sm-2">
          <label>Priorité</label>
          <br />
          <label>{ordreOperation}</label>
        </div>
        <div className="col-sm-4">
          <div className="form-group">
            <div>
              <label>Choisir une operation</label>

              <Select
                closeMenuOnSelect={true}
                components={animatedComponents}
                defaultValue={selectedOption}
                onChange={onChangeSelectedOperation}
                options={allOperations}
                placeholder={operationSelectPlaceHolder}
              />
            </div>
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <label>Temps Réglage</label>
            <input
              onChange={onChangeTempsReglageHandler}
              value={tempsReglage}
              type="number"
              min="0"
              id="quantity"
              className="form-control"
            />
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <label>Temps Machine</label>
            <input
              onChange={onChangeTempsMachineHandler}
              value={tempsMachine}
              type="number"
              min="0"
              id="quantity"
              className="form-control"
            />
          </div>
        </div>
        <div className="col-sm-2">
          <div className="form-group">
            <label>Temps Transfert</label>
            <input
              onChange={onChangeTempsTransfertHandler}
              value={tempsTransfert}
              type="number"
              min="0"
              id="quantity"
              className="form-control"
            />
          </div>
        </div>
      </div>
    );
  }

  const onChangeSelectedProductDechetComposant = (selectedOptionn) => {
    setSelectedOptionComponentDechet();
    setProductDechetComposantId(selectedOptionn.value);
    setProductDechetComposantSelectPlaceHolder(selectedOptionn.label);
    setShowProductDechet(true);
  };

   const onAddProductDechetToList = (event) => {
      let productRef = null;
      let uomRef = null;
  
      let exist = false;
      let indexInDataTable;
      try {
        productDechetMapById.forEach((element, index) => {
          if (element.idProduct === productDechetComposantId) {
            indexInDataTable = index;
            exist = true;
            throw "Break";
          }
        });
      } catch (e) {
        if (e !== "Break") throw e;
      }
  
      try {
        availableProductsComponents.forEach((element) => {
          if (element.id === productDechetComposantId) {
            let codeProduct = "*";
            if (element.productCode !== undefined) {
              codeProduct = element.productCode;
            }
            let barCodeProduct = "*";
            if (element.barcode) {
              barCodeProduct = element.barcode;
            }
            let label = codeProduct + "-" + barCodeProduct + "-" + element.name;
            productRef = label;
            console.log("productRef", productRef);
            throw "Break";
          }
        });
      } catch (e) {
        if (e !== "Break") throw e;
      }
  
      try {
        availableUOM.forEach((element) => {
          if (element.id === uomComposant) {
            uomRef = element.name;
            console.log("uomRef", uomRef);
            throw "Break";
          }
        });
      } catch (e) {
        if (e !== "Break") throw e;
      }
  
      console.log("productComposantId", productDechetComposantId);
      if (productDechetComposantId === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : Sélectionnez un produit ");
      } else if (quantityComposant === 0) {
        setOpenErrorAlert(true);
        setErrorAlertText(
          "Erreur : la quantité du produit doit être supérieur à zéro "
        );
      } else {
        if (!exist) {
          setProductDechetMapById((previoustate) => [
            ...previoustate,
            {
              productRef: productRef,
              idProduct: productDechetComposantId,
              uom: uomComposant,
              uomName: uomRef,
              quantity: quantityComposant,
            },
          ]);
          setProductDechetTableData((previoustate) => [
            ...previoustate,
            {
              productRef: productRef,
              idProduct: productDechetComposantId,
              uom: uomComposant,
              uomName: uomRef,
              quantity: quantityComposant,
            },
          ]);
        } else if (exist) {
          let productUpdateValue = productDechetTableData[indexInDataTable];
          productUpdateValue.uom = uomComposant;
          productUpdateValue.uomName = uomRef;
  
          productUpdateValue.quantity = quantityComposant;
  
          let modelData = update(productDechetTableData, {
            [indexInDataTable]: { $merge: productUpdateValue },
          });
  
          let tableData = update(productDechetMapById, {
            [indexInDataTable]: { $merge: productUpdateValue },
          });
          if (productDechetTableData[indexInDataTable].uom !== uomComposant) {
            setOpenInfoAlert(true);
            setInfoAlertText(
              "Info : Vous avez actualisé l'unité de mesure' :  " + uomRef
            );
          } else if (
            productDechetTableData[indexInDataTable].quantity !== quantityComposant
          ) {
            setOpenInfoAlert(true);
            setInfoAlertText(
              "Info : Vous avez actualisé la quantité du produit : " + productRef
            );
          }
          setProductDechetMapById(tableData);
          setProductDechetTableData(modelData);
        }
      }
      etatInitial();
  
      console.log("productTableData ", productDechetTableData);
    };
  function productDechetsDetail() {
    if (showProductDechet) {
      return (
        <>
          {" "}
          <div class="row">
            <div className="col-sm-6">
              <div className="form-group">
                <div>
                  <label>Choisir une unité de mesure</label>

                  <Select
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedOptionUOMComposant}
                    onChange={onChangeSelectedUMOComposant}
                    options={allUOM}
                    placeholder={uomComposantSelectPlaceHolder}
                  />
                </div>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="form-group">
                <label>Quantité théorique</label>
                <input
                  onChange={onChangeQuantityComposantHandler}
                  value={quantityComposant}
                  type="number"
                  min="0"
                  id="quantity"
                  className="form-control"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div className="col-sm-12  text-center">
              <button
                style={{ marginBottom: 20 }}
                className="btn btn-dark"
                onClick={onAddProductDechetToList}
              >
                <i class="fas fa-plus"></i>
                Liste des déchets{" "}
              </button>
            </div>
          </div>
        </>
      );
    }
  }
  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <div>
                        <label>Le produit</label>
                        <br />
                        <label>
                          {boms.product?.productCode}-{boms.product?.name}
                        </label>

                        {/* <Select
                            key={"produit"}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            defaultValue={selectedOption}
                            onChange={onChangeSelectedProduct}
                            options={allProducts}
                            placeholder={productSelectPlaceHolder}
                          /> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <div>
                        <label>Choisir une unité de mesure</label>

                        <Select
                          closeMenuOnSelect={true}
                          components={animatedComponents}
                          defaultValue={selectedOptionUOM}
                          onChange={onChangeSelectedUMO}
                          options={allUOM}
                          placeholder={uomSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label>Quantité</label>
                      <input
                        onChange={onChangeQuantityHandler}
                        value={quantity}
                        type="number"
                        min="0"
                        id="quantity"
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <div>
                        <label>Choisir les composants</label>

                        <Select
                          key={"composants"}
                          closeMenuOnSelect={true}
                          components={animatedProductComponents}
                          defaultValue={selectedOptionComponent}
                          onChange={onChangeSelectedProductComposant}
                          options={allProductsComponents}
                          placeholder={productComposantSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {productDetail()}

                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      {productTableData && (
                        <ToolkitProvider
                          keyField="idProduct"
                          data={productTableData}
                          columns={columnsWithDelete}
                          onTableChange={handleTableChange}
                        >
                          {(props) => (
                            <div>
                              <div className="row">
                                <BootstrapTable
                                  {...props.baseProps}
                                  striped
                                  hover
                                  condensed
                                />
                              </div>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <div class="row">
              <div className="col-sm-12">
                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <div>
                        <label>Choisir les déchets</label>

                        <Select
                          key={"dechets"}
                          closeMenuOnSelect={true}
                          components={animatedProductDechetComponents}
                          defaultValue={selectedOptionComponentDechet}
                          onChange={onChangeSelectedProductDechetComposant}
                          options={allProductsComponents}
                          placeholder={productDechetComposantSelectPlaceHolder}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {productDechetsDetail()}

                <div class="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      {productDechetTableData && (
                        <ToolkitProvider
                          keyField="idProduct"
                          data={productDechetTableData}
                          columns={columnsWithDelete}
                          onTableChange={handleTableChange}
                        >
                          {(props) => (
                            <div>
                              <div className="row">
                                <BootstrapTable
                                  {...props.baseProps}
                                  striped
                                  hover
                                  condensed
                                />
                              </div>
                            </div>
                          )}
                        </ToolkitProvider>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );

      case 3:
        return (
          <div>
            <div class="row">{listOperations()}</div>
          </div>
        );

      case 4:
        return (
          <div className="row">
            <span class="text-dark">
              Avant de cliquer sur terminé, vous devez être sûr des informations
              saisies
            </span>
          </div>
        );
      default:
        return "Unknown step";
    }
  }

  const onAddProductToList = (event) => {
    let productRef = null;
    let uomRef = null;

    let exist = false;
    let indexInDataTable;
    try {
      productMapById.forEach((element, index) => {
        if (element.idProduct === productComposantId) {
          indexInDataTable = index;
          exist = true;
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      availableProductsComponents.forEach((element) => {
        if (element.id === productComposantId) {
          let codeProduct = "*";
          if (element.productCode !== undefined) {
            codeProduct = element.productCode;
          }
          let barCodeProduct = "*";
          if (element.barcode) {
            barCodeProduct = element.barcode;
          }
          let label = codeProduct + "-" + barCodeProduct + "-" + element.name;
          productRef = label;
          console.log("productRef", productRef);
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    try {
      availableUOM.forEach((element) => {
        if (element.id === uomComposant) {
          uomRef = element.name;
          console.log("uomRef", uomRef);
          throw "Break";
        }
      });
    } catch (e) {
      if (e !== "Break") throw e;
    }

    console.log("productComposantId", productComposantId);
    if (productComposantId === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText("Erreur : Sélectionnez un produit ");
    } else if (quantityComposant === 0) {
      setOpenErrorAlert(true);
      setErrorAlertText(
        "Erreur : la quantité du produit doit être supérieur à zéro "
      );
    } else {
      if (!exist) {
        setProductMapById((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productComposantId,
            uom: uomComposant,
            uomName: uomRef,
            quantity: quantityComposant,
          },
        ]);
        setProductTableData((previoustate) => [
          ...previoustate,
          {
            productRef: productRef,
            idProduct: productComposantId,
            uom: uomComposant,
            uomName: uomRef,
            quantity: quantityComposant,
          },
        ]);
      } else if (exist) {
        let productUpdateValue = productTableData[indexInDataTable];
        productUpdateValue.uom = uomComposant;
        productUpdateValue.uomName = uomRef;

        productUpdateValue.quantity = quantityComposant;

        let modelData = update(productTableData, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });

        let tableData = update(productMapById, {
          [indexInDataTable]: { $merge: productUpdateValue },
        });
        if (productTableData[indexInDataTable].uom !== uomComposant) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé l'unité de mesure' :  " + uomRef
          );
        } else if (
          productTableData[indexInDataTable].quantity !== quantityComposant
        ) {
          setOpenInfoAlert(true);
          setInfoAlertText(
            "Info : Vous avez actualisé la quantité du produit : " + productRef
          );
        }
        setProductMapById(tableData);
        setProductTableData(modelData);
      }
    }
    etatInitial();

    console.log("productTableData ", productTableData);
  };

  function etatInitial() {
    setSelectedOption(null);

    setShowProduct(false);
  }

  return (
    boms != null && (
      <div className="content-wrapper" style={{ marginTop: "0" }}>
        <section className="content-header">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6"></div>
              <div className="col-md-6">
                <ol class="breadcrumb float-sm-right">
                  <li className="breadcrumb-item">
                    <Link to="/" style={{ color: "black" }}>
                      Home
                    </Link>
                  </li>

                  <li className="breadcrumb-item">
                    <Link to="/bonsDeCommande" style={{ color: "black" }}>
                      Les BOMs
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item active"
                    style={{ color: "black" }}
                  >
                    Ajouter
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section className="content ">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header">
                    <div className={classes.root}>
                      <Stepper activeStep={activeStep}>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </div>
                  </div>

                  {activeStep === steps.length ? (
                    <div class="card-body">
                      <div class="row" style={{ marginTop: 2 }}></div>
                      Toutes les étape ont complétées avec succès
                      <Button onClick={handleReset} className={classes.button}>
                        Réinitialiser
                      </Button>
                    </div>
                  ) : (
                    <div>
                      <div class="card-body">{getStepContent(activeStep)}</div>
                      <div class="card-footer" style={{ marginTop: "1%" }}>
                        <button
                          disabled={activeStep === 0}
                          className="btn btn-light"
                          onClick={handleBack}
                        >
                          Précédent
                        </button>

                        <button class="btn btn-dark" onClick={handleNext}>
                          {activeStep === steps.length - 1
                            ? "Terminer"
                            : "Suivant"}
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={4000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
        <Snackbar
          open={openSuccessAlert}
          autoHideDuration={2000}
          onClose={handleSuccessClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert
            variant="filled"
            onClose={handleSuccessClose}
            severity="success"
          >
            {successAlertText}
          </Alert>
        </Snackbar>

        <Snackbar
          open={openErrorAlert}
          autoHideDuration={2000}
          onClose={handleEroorClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleEroorClose} severity="error">
            {errorAlertText}
          </Alert>
        </Snackbar>
      </div>
    )
  );
};
export default withLoader(UpdateBOM);
